import Vue from 'vue'
import Vuex from 'vuex'

import shared from './modules/Shared'
import auth from './modules/FBAuthentication'
import users from './modules/FBUsers'
import groups from './modules/FBGroups'
import schools from './modules/FBSchools'
import scholae from './modules/FBScholae'
import shares from './modules/FBShares'
import logs from './modules/FBLogging'
import storage from './modules/FBStorage'
import chatRef from './modules/FBChatRef'
import chatRefStatus from './modules/FBChatRefStatus'
import chatMessage from './modules/FBChatMessage'
import chatUnread from './modules/FBChatUnread'
import students from './modules/FBStudents'
import postcode from './modules/FBPostcode'
import holidays from './modules/FBHolidays'
import scheduleEvents from './modules/FBScheduleEvents'
import templateEvents from './modules/FBTemplateEvents'
import scheduleTasks from './modules/FBScheduleTasks'
import templateTasks from './modules/FBTemplateTasks'
import locations from './modules/FBLocation'
import metricsPlans from './modules/FBMetricsPlans'
import metricsActs from './modules/FBMetricsActs'
import metricsStatus from './modules/FBMetricsStatus'
import metricsFees from './modules/FBMetricsFees'
import metricsRevises from './modules/FBMetricsRevises'
import notices from './modules/FBNotices'
import publicUsers from './modules/FBPublicUsers'
import publicGroups from './modules/FBPublicGroups'
import tags from './modules/FBTags'
import statuses from './modules/FBStatuses'
import sharesStatics from './modules/FBSharesStatics'
import sharesPublics from './modules/FBSharesPublics'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    shared,
    auth,
    users,
    groups,
    schools,
    scholae,
    shares,
    logs,
    storage,
    chatRef,
    chatRefStatus,
    chatMessage,
    chatUnread,
    students,
    postcode,
    holidays,
    scheduleEvents,
    templateEvents,
    scheduleTasks,
    templateTasks,
    locations,
    metricsPlans,
    metricsActs,
    metricsFees,
    metricsStatus,
    metricsRevises,
    notices,
    publicUsers,
    publicGroups,
    tags,
    statuses,
    sharesStatics,
    sharesPublics
  },
  strict: process.env.NODE_ENV !== 'production'
})

export default store
